import * as React from 'react';
import styled from "styled-components";
import {Title, SectionTitle} from "../../styled"
import Card from "./componetns/Card";
import TariffsImage from '../../images/tariffs.png';

const Container = styled.div`
  display: flex;
  background: #2A2A2B;
  padding-bottom: 32px;

  ${Title} {
    max-width: 686px;
    margin-bottom: 20px;
    
    span {
      color: #5C7EF7;
    }
  }

  ${SectionTitle} {
    color: white;
  }
`;

const Box = styled.div`
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: 40px;
`;

const SubTitle = styled.div`
  margin-bottom: 32px;
`;

const ImageBox = styled.div`
  max-width: 760px;
  width: 100%;
  
  img {
    width: 100%;
    object-fit: cover;
  }
`;

const Cards = styled.div`
  display: grid;
  gap: 20px;
`;

const Content = styled.div`
  margin: auto;
  width: 100%;
  max-width: 1340px;
  padding-left: 90px;
  padding-top: 40px;
  color: white;

  @media screen and (max-width: 1270px) {
    padding: 20px 10px;
  }

  @media screen and (max-width: 1140px) {
    ${Box} {
      display: flex;
      align-items: center;
    }
  }
  
  @media screen and (max-width: 900px) {
    ${Box} {
      flex-direction: column;
    }
  }
`;

/**
 * render landing page tariffs section
 * @constructor
 */
export default function Tariffs(): React.ReactElement {
  return (
    <Container>
      <Content>
        <SectionTitle>ресурсы и время</SectionTitle>
        <Title>
          Самые <span>гибкие тарифы</span> с возможностью пост-оплаты
        </Title>
        <SubTitle>Сначала работа — потом оплата. Все честно.</SubTitle>
        <Box>
          <Cards>
            <Card
              number={1}
              title={'Шаг в 100 участников для выбора тарифа'}
            />
            <Card
              number={2}
              title={'Мы не ограничиваем доступ к функциям'}
              description={'Даже на минимальном тарифе'}
            />
            <Card
              number={3}
              title={'Скидки за оплату нескольких месяцев сразу'}
            />
          </Cards>
          <ImageBox>
            <img src={TariffsImage} alt="tariffs"/>
          </ImageBox>
        </Box>
      </Content>
    </Container>
  );
}
